import _defineProperty from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { getSizeChannel, POSITION_SCALE_CHANNELS } from '../channel';
import { isFieldOrDatumDef } from '../channeldef';
import * as log from '../log';
import { isUnitSpec } from '../spec/unit';
import { isEmpty } from '../util';
export var RangeStepNormalizer = /*#__PURE__*/function () {
  function RangeStepNormalizer() {
    _classCallCheck(this, RangeStepNormalizer);

    this.name = 'RangeStep';
  }

  _createClass(RangeStepNormalizer, [{
    key: "hasMatchingType",
    value: function hasMatchingType(spec) {
      var _a;

      if (isUnitSpec(spec) && spec.encoding) {
        var _iterator = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var channel = _step.value;
            var def = spec.encoding[channel];

            if (def && isFieldOrDatumDef(def)) {
              if ((_a = def === null || def === void 0 ? void 0 : def.scale) === null || _a === void 0 ? void 0 : _a['rangeStep']) {
                return true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return false;
    }
  }, {
    key: "run",
    value: function run(spec) {
      var _a;

      var sizeMixins = {};
      var encoding = Object.assign({}, spec.encoding);

      var _iterator2 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var channel = _step2.value;
          var sizeType = getSizeChannel(channel);
          var def = encoding[channel];

          if (def && isFieldOrDatumDef(def)) {
            if ((_a = def === null || def === void 0 ? void 0 : def.scale) === null || _a === void 0 ? void 0 : _a['rangeStep']) {
              var scale = def.scale,
                  defWithoutScale = __rest(def, ["scale"]);

              var _b = scale,
                  rangeStep = _b.rangeStep,
                  scaleWithoutRangeStep = __rest(_b, ["rangeStep"]);

              sizeMixins[sizeType] = {
                step: scale['rangeStep']
              };
              log.warn(log.message.RANGE_STEP_DEPRECATED);
              encoding = Object.assign(Object.assign({}, encoding), _defineProperty({}, channel, Object.assign(Object.assign({}, defWithoutScale), isEmpty(scaleWithoutRangeStep) ? {} : {
                scale: scaleWithoutRangeStep
              })));
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return Object.assign(Object.assign(Object.assign({}, sizeMixins), spec), {
        encoding: encoding
      });
    }
  }]);

  return RangeStepNormalizer;
}();